<template>
  <ConfirmationDialog
    :confirm-text="$t('input.btn.close')"
    :action-function="close"
    :show-dialog="rootStore.cartFailureDialog"
    :text="$t('error.p.cartService')"
    :title="$t('error.header.cartService')"
    text-class="text-error"
    emit-close-on-escape
    @close="close"
  />
</template>

<script lang="ts" setup>
import ConfirmationDialog from '~/components/base/ConfirmationDialog.vue'
import { useRootStore } from '~/stores/root'

// Reads the same flag flagCartFailure writes. This dialog previously rendered on
// `cartStore.isFailure`, which nothing ever set to true, while the cart service raised
// `rootStore.cartFailureDialog`, which nothing ever read — so a cart 5xx set a flag no one
// watched and the dialog could never appear. AB#63254
const rootStore = useRootStore()

const close = () => {
  rootStore.cartFailureDialog = false
}
</script>
<style lang="scss" scoped>

</style>
